import { useMutation, useQueryClient } from "@tanstack/react-query";
import { updateRoles } from "../../apis/roles";

export const useUpdatePartnerRoles = () => {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: (selectedRoles) => updateRoles(selectedRoles),
    onSuccess: (data) => {
      queryClient.setQueryData(["partner_data"], (oldData) => {
        return { ...oldData, ...data };
      });
    },
    onError: (error) => {
      console.error("Error Updating Partner Roles!", error);
    },
  });
};
